import React from "react";
import ReactDOM from "react-dom";
import App from "./app.jsx";
import { HashRouter } from "react-router-dom";

// css
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-quill/dist/quill.snow.css";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "simple-line-icons/css/simple-line-icons.css";
import "flag-icon-css/css/flag-icon.min.css";
import "bootstrap-social/bootstrap-social.css";
import "./styles/index.css";
import "./styles/scss/index.scss";

// ========================================

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById("root"),
);
